
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  taskId: null, // starts as null
};

const taskSlice = createSlice({
  name: 'taskDashboard',
  initialState,
  reducers: {
    setTaskId(state, action) {
      state.taskId = action.payload; // e.g., a string/number/UUID
    },
    clearTaskId(state) {
      state.taskId = null;
    },
  },
});

export const { setTaskId, clearTaskId } = taskSlice.actions;

// Selector
export const selectTaskId = (state) => state.task.taskId;

export default taskSlice.reducer;
